import { h, Fragment, Component, createRef } from 'preact'
import Pikaday from 'pikaday'

class ReactPikadayComponent extends Component {
  constructor(props) {
    super(props)
    this.pikadayRef = createRef()
    this.triggerRef = createRef()
    this.containerRef = createRef()
  }

  componentDidMount() {
    const { value } = this._getValueLink(this.props)

    this._setupPikaday()
    this._setDateIfChanged(value)
  }

  componentWillReceiveProps(nextProps) {
    const newDate = this._getValueLink(nextProps).value
    const lastDate = this._getValueLink(this.props).value

    this._setDateIfChanged(newDate, lastDate)
    this._setMinDateIfChanged(nextProps.minDate, this.props.minDate)
    this._setMaxDateIfChanged(nextProps.maxDate, this.props.maxDate)
  }

  componentDidUpdate(prevProps) {
    // update if container is set
    if (!prevProps.container && this.props.container) {
      const newDate = this._getValueLink(this.props).value
      const lastDate = this._getValueLink(prevProps).value

      this.pikaday.destroy()
      this._setupPikaday()
      this._setDateIfChanged(newDate, lastDate)
    }

    if (!prevProps.disableDayFn !== this.props.disableDayFn) {
      this.pikaday._o.disableDayFn = this.props.disableDayFn
      this.pikaday.draw()
    }

    this.pikaday.setStartRange(this.props.startRange)
    this.pikaday.setEndRange(this.props.endRange)
  }

  componentWillUnmount() {
    this.pikaday.destroy()
  }

  render() {
    const {
      id,
      type,
      className,
      name,
      tabIndex,
      disabled,
      placeholder,
      readOnly,
      style,
      label,
      icon
    } = this.props

    return (
      <div ref={this.containerRef} class="relative" style={style}>
        {icon}
        <button
          ref={this.triggerRef}
          type="button"
          class="select-toggle relative z-20 appearance-none block rounded-none w-full bg-white border border-grey-light text-current py-0 pl-11 pr-4 xs:pr-6 -xs:text-sm text-left expanded:line-bottom"
          style="height:65px;"
        >
          {label}
        </button>
        <input
          id={id}
          type="hidden"
          ref={this.pikadayRef}
          name={name}
          className={className}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          tabIndex={tabIndex}
        />
      </div>
    )
  }

  _getValueLink(props) {
    return (
      props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      }
    )
  }

  _setupPikaday() {
    const el = this.pikadayRef.current
    const { requestChange } = this._getValueLink(this.props)
    const { value, onChange, valueLink, ...pikadayOptions } = this.props // eslint-disable-line no-unused-vars
    const options = Object.assign({}, pikadayOptions, {
      field: el,
      onSelect: requestChange,
      trigger: this.triggerRef.current,
      container: this.containerRef.current,
      onOpen: () => {
        this.triggerRef.current.style.borderColor = 'transparent'
        this.triggerRef.current.setAttribute('data-expanded', '')
      },
      onClose: () => {
        this.triggerRef.current.style.borderColor = ''
        this.triggerRef.current.removeAttribute('data-expanded')
      },
      toString(date) {
        return `${date
          .getDate()
          .toString()
          .padStart(2, '0')}/${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}/${date.getFullYear()}`
      },
      parse(str) {
        let [day, month, year] = str.split('/')
        return new Date(
          parseInt(year, 10),
          parseInt(month, 10) - 1,
          parseInt(day, 10)
        )
      },
      onDraw: pika => {
        if (this.props.onBail) {
          if (this.bail) {
            try {
              this.bail.parentNode.removeChild(this.bail)
            } catch (_) {}
          }
          this.bail = document.createElement('button')
          this.bail.className =
            'absolute appearance-none bg-transparent border-0 p-0 rounded-none inline-flex text-grey-dark hover:text-black transition-color text-sm underline'
          this.bail.style.left = '31px'
          this.bail.style.bottom = '24px'
          this.bail.textContent = 'Can’t find return date?'
          this.bail.addEventListener('click', this.props.onBail)
          pika.el.appendChild(this.bail)
        }
      }
    })

    this.pikaday = new Pikaday(options)
  }

  _setDateIfChanged(newDate, prevDate) {
    this._setDate(newDate, prevDate, newTime => {
      if (isNaN(newTime)) {
        // workaround for pikaday not clearing value when date set to false
        const el = this.pikadayRef.current
        el.value = ''
      }
      this.pikaday.setDate(newDate, true) // not trigger onSelect
    })
  }

  _setMinDateIfChanged(newDate, prevDate) {
    this._setDate(newDate, prevDate, () => {
      this.pikaday.setMinDate(newDate)
    })
  }

  _setMaxDateIfChanged(newDate, prevDate) {
    this._setDate(newDate, prevDate, () => {
      this.pikaday.setMaxDate(newDate)
    })
  }

  _setDate(newDate, prevDate, setter) {
    const newTime = newDate ? newDate.getTime() : null
    const prevTime = prevDate ? prevDate.getTime() : null

    if (newTime !== prevTime) {
      setter(newTime)
    }
  }
}

export default ReactPikadayComponent



// WEBPACK FOOTER //
// ./src/js/widget/Pikaday.js